import $ from 'jquery';
/* global x5script */

class ShowAll {
  constructor() {
    this.document = $(document);
    this.bindEvents();
  }

  bindEvents() {
    this.document.on('click', '.js-show-all', e => {
      const button = $(e.currentTarget);
      const targetSelector = button.data('target');
      const currentSection = document.querySelector(targetSelector);

      if (!currentSection) {
        return;
      }

      const buttons = $(currentSection).find('.js-show-all');
      buttons
        .prop('disabled', true)
        .attr('aria-busy', 'true')
        .addClass('is-loading');

      window
        .fetch(button.data('url'), {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(
              `Show all request failed with status ${response.status}`,
            );
          }

          return response.text();
        })
        .then(html => {
          const page = new window.DOMParser().parseFromString(
            html,
            'text/html',
          );
          const nextSection = page.querySelector(targetSelector);

          if (!nextSection) {
            throw new Error(
              'Show all response did not contain the target section',
            );
          }

          const reduceMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)',
          ).matches;

          currentSection.parentNode.replaceChild(nextSection, currentSection);
          nextSection.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'start',
          });
        })
        .catch(error => {
          buttons
            .prop('disabled', false)
            .attr('aria-busy', 'false')
            .removeClass('is-loading');

          // eslint-disable-next-line no-alert
          window.alert(`${x5script.showAllErrorMessage}\n\n${error.message}`);
        });
    });
  }
}

export default new ShowAll();



// WEBPACK FOOTER //
// ./src/scripts/modules/show-all.js